import {FC, ReactNode} from 'react';

import RatingStarIcon from '@/assets/icons/rating-star.svg?react';
import AppLogo from '@/shared/components/AppLogo';
import {getMediaUrl} from '@/shared/lib/getMediaUrl';
import {APP_ROUTES} from '@/utils_legacy/routes';

export interface AuthSectionProps {
  children?: ReactNode;
}

const AuthSection: FC<AuthSectionProps> = ({children}) => {
  return (
    <section className="relative">
      <picture>
        <source
          media="(max-width: 640px)"
          srcSet={getMediaUrl('landing/top_mob.webp')}
        />
        <img
          src={getMediaUrl('landing/top_desk.webp')}
          alt="welcome"
          className="absolute top-0 left-0 h-full w-full object-cover"
        />
      </picture>
      <div className="relative z-10 flex min-h-svh select-none flex-col items-center gap-5 text-center text-secondary sm:gap-9">
        <AppLogo className="absolute top-5 left-4 h-[45px] w-[72px] text-white sm:top-4 sm:left-11 sm:h-[63px] sm:w-[120px]" />
        <h1
          className="mt-[20dvh] flex max-w-64 justify-center text-center font-bold text-4xl/[150%] text-secondary sm:text-7xl/[125%]"
          style={{
            textShadow:
              '2px 2px 5px rgba(0, 0, 0, 0.3), -2px -2px 5px rgba(0, 0, 0, 0.2)',
          }}
        >
          Find your international soulmate
        </h1>
        <div className="flex items-center gap-4">
          <div className="flex flex-col items-center gap-1">
            <span className="font-bold text-xl sm:text-3xl">20M+</span>
            <span className="sm:text-xl">downloads</span>
          </div>
          <div className="h-10 w-[1px] bg-white" />
          <div className="flex flex-col items-center gap-1">
            <span className="flex items-center gap-1 font-bold text-xl sm:gap-1.5 sm:text-3xl">
              4.6 <RatingStarIcon className="w-4 sm:w-5" />
            </span>
            <span className="sm:text-xl">500k+ reviews</span>
          </div>
        </div>
        <div className="mt-auto flex flex-col items-center gap-2.5">
          {children}
          <div className="mt-2.5 mb-6 text-xs sm:mb-16 sm:text-sm">
            By continuing, you agree to the
            <a
              href={APP_ROUTES.TermsOfServiceGroup}
              className="ml-1 cursor-pointer font-normal text-white hover:text-white"
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>
            ,
            <div>
              <a
                href={APP_ROUTES.PrivacyPolicyGroup}
                className="mr-1 ml-1 cursor-pointer font-normal text-white hover:text-white"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
              and
              <a
                href="/community-guidelines"
                className="mr-1 ml-1 cursor-pointer font-normal text-white hover:text-white"
                target="_blank"
                rel="noreferrer"
              >
                Community Guidelines
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthSection;
